import { getAppInfo } from '@/utils/base'

export default {
    discover_tab: '발견',
    mine_tab: 'MY',
    bookshelf_tab: '책갈피',
    ranking: '베스트',
    more: '더 보기',
    search_stories: '검색',
    'you_might_like': '추천',
    'chapter': '회',
    'chapters': '회',
    'completed': '완료',
    'reviews': '관심',
    'words': '글자수',
    'summary': '줄거리',
    'read_now': '첫회보기',
    'add_to_library': '책갈피 추가',
    'select_payment_method': '구매 방법 선택',
    'most_popular': '인기',
    'weekly': 'weekly',
    'subscribe': '구독',
    'login': '로그인',
    'register': '회원가입',
    'logout': '로그아옷',
    'sign_in_to_get_more': '',
    'vip_status_inactive': 'vip 상태:불가용',
    'active_wireless_reading_now': '',
    'vip_activated': 'VIP 가용',
    'question': '고객 센터',
    'terms_of_service': '서비스',
    'privacy_policy': '개인정보보호',
    'search': '검색',
    'user': '아이디',
    'password': '비밀번호',
    'by_continuing_you_agree_with_the': '실명 인증된 아이디로 가입, 위치기반서비스 이용약관(선택), 이벤트・혜택 정보 수신(선택) 동의를 포함합니다.',
    'and': ',',
    'username_or_password_cannot_be_empty': '아이디 또는 비밀번호를 입력해 주세요.',
    'username_or_password_length_must_be_greater_than_8': '아이디 또는 비밀번호는 8위 이상입니다',
    'register_success': '회원 가입 성공',
    'login_success': '로그인 성공',
    'logout_success': '로그아옷 성공',
    'rules': '규칙',
    'vip_member_benefits': 'VIP 권익',
    'bookshelf_none': '책갈피에는 책이 없습니다',
    'go_to_the_bookstore': '발견으로 가세요 ',
    'search_none': `구매 기록이 없습니다`,
    'go_to_pay': '잠시만 기다려 주세요',
    'continue': '계속',
    'PRIVACY': {
        content: `
            <h1>드리아노벨 개인정보 처리방침</h1>
            <section>
                <h2>드리아노벨 개인정보 처리방침에 오신 것을 환영합니다.</h2>
                <p>드리아노벨 애플리케이션 및 서비스를 이용할 때, 귀하는 당사의 정보 처리 방식을 신뢰한다는 것을 의미합니다. 본 개인정보 처리방침은 당사가 수집하는 정보의 종류, 수집 이유, 사용 방법을 이해하는 데 도움을 주기 위해 작성되었습니다. 당사의 관행을 이해하는 것이 중요하므로 본 정책을 꼼꼼히 읽어주시기 바랍니다.</p>
            </section>

            <section>
                <h2>수집하는 정보의 종류</h2>
                <p>본 방침은 다음 사항을 설명합니다:</p>
                <ul>
                    <li>수집하는 정보 및 수집 이유</li>
                    <li>정보 사용 방식</li>
                    <li>수집하는 정보</li>
                </ul>
            </section>
            <section>
                <h2>
                    모든 이용자에게 향상된 서비스를 제공하기 위해 법적 목적으로 정보를 수집할 수 있습니다. 이에는 기본 정보(예: 사용 언어)와 복잡한 정보(예: 독서 선호도)가 포함됩니다.
                </h2>
                <p>
                    정보 수집 방법:
                </p>
                <p>
                    귀하가 제공하는 정보:
                </p>
                <p>
                    도서 다운로드 또는 소셜 서비스 이용 시 드리아노벨 계정 가입 필요
                </p>
                <p>계정 생성 시 휴대전화 번호, 연동된 소셜 계정(구글+, 페이스북 등) 정보 요청
해당 정보는 계정에 저장되며, 앱 내에서 소셜 계정 연동 설정 제공</p>
                <p>서비스 이용 중 획득하는 정보:</p>
                <p>서비스 사용 방식 및 패턴(온라인 서점 탐색 여부, 선호 장르 등)</p>
                <p>디바이스 정보: 하드웨어 모델, 고유 디바이스 식별자, 모바일 네트워크 정보</p>
                <p>위치 정보: IP 주소, GPS 등을 활용한 실제 위치 데이터 처리</p>
                <p>독서 정보: 메모, 열람 기록, 도서 미리보기 내역</p>
                <p>정보 사용 목적</p>
                <p>서비스 제공, 유지, 보안 강화 및 신규 서비스 개발</p>
                <p>맞춤형 콘텐츠 제공(예: 선호 장르 도서 추천)</p>
                <p>초기 게스트 계정 설정을 통한 빠른 서비스 이용 환경 구성</p>
                <p>위치 기반 소셜 기능("주변 사용자" 추천) 활성화</p>
                <p>클라우드 저장을 통한 계정 간 독서 기록 동기화</p>
                <p>공유 정보</p>
                <p>도서/서평 공유 등 소셜 기능 제공 시 자동 기록 없음</p>
                <p>공유 시 개인정보 보안 주의 필요</p>
                <p>개인정보 열람 및 수정</p>
                <p>서비스 이용 시 항상 개인정보 접근 권한 보장</p>
                <p>오류 시 신속한 수정/삭제 절차 제공(법적 보존 의무 경우 제외)</p>
                <p>신원 확인 후 요청 처리</p>
                <p>기술적 한계로 인해 백업 시스템 잔여 데이터 보유 가능</p>
                <p>데이터 삭제 요청</p>
                <p>ops@novellettes.com으로 삭제 요청 가능</p>
                <p>사례별 검토 후 처리(사기 방지, 법적 의무 사유로 일부 데이터 보유)</p>
                <p>계정 삭제 시 플랫폼 접근 권한 상실</p>
                <p>제품 권한 요청</p>
                <p>특정 기능 제공을 위한 시스템 자원 접근 권한:</p>
                <p>미디어/파일: 도서 저장을 위한 저장공간 사용</p>
                <p>카메라: 도서 스캔 기능("스캔"을 통한 전자책 검색)</p>
                <p>Wi-Fi 정보: 대용량 플러그인 다운로드 권장</p>
                <p>디바이스 ID: 게스트 계정 초기화 용도</p>
                <p>적용 범위</p>
                <p>본 방침은 ${getAppInfo().company}에 적용</p>
                <p>제3자 광고주의 쿠키/픽셀 태그 사용 행위는 본 방침 미포함</p>
                <p>준거법</p>
                <p>본 약관은 중화인민공화국 홍콩 특별행정구 법률의 관할을 받습니다.</p>
                <p>문의사항이 있을 경우 ops@novellettes.com으로 연락 주시면 24시간 내 답변드리겠습니다.</p>
            </section>
        
        `
    },
    'SERVICE': {
        content: `
                <h1>**드리아노벨 서비스 이용 약관**  </h1>
                <h2>**용어 사용**</h2>
                <p>드리아노벨에 오신 것을 환영합니다!  </p>
                <p>본 서비스 약관(이하 "약관")은 ${getAppInfo().company}와 드리아노벨 이용자(이하 "이용자") 간에 체결되며, "드리아노벨" 애플리케이션(이하 "본 서비스")의 설치·사용 및 관련 사항을 규정합니다. "동의함"을 클릭하거나 본 약관을 수락하는 경우, 이용자는 당사와 본 약관의 모든 조항에 동의한 것으로 간주됩니다.  </p>
                <h2>**제1조 (이용자 서비스)**  </h2>
                <p>① 이용자는 본 서비스를 설치·복제·다운로드·접근 또는 기타 방식으로 사용하기 전에 (i) 본 약관을 전체 검토 및 동의해야 하며, (ii) 당사가 지정한 웹사이트 또는 매체에서만 본 서비스를 다운로드해야 합니다. 이용자의 본 약관 위반으로 발생한 모든 위험 및/또는 손실에 대해 당사는 책임을 지지 않습니다.  </p>
                <h2>**제2조 (지식재산권)**  </h2>
                <p>① 당사는 본 서비스의 저작권자입니다. 본 서비스와 관련된 모든 지식재산권(텍스트·아이콘·그래픽·이미지·색상·레이아웃·데이터 등 포함)은 저작권법 및 국제 조약에 의해 보호됩니다. 이용자는 당사의 사전 서면 동의 없이 역공학·디컴파일·분해를 수행할 수 없습니다.  </p>
                <p>② 이용자가 본 서비스에서 획득한 콘텐츠는 (i) 미디어에 게시·재생, (ii) 상업적 목적의 재편집, (iii) 기타 상업적 이용이 금지되며, 개인적·비상업적 용도로만 보관 가능합니다.  </p>
                <h2>**제3조 (결제)**  </h2>
                <p>① 본 서비스는 비상업적 목적으로 무료 다운로드 및 사용이 가능합니다.  </p>
                <p>② 데이터 요금은 이동통신사 정책에 따라 부과될 수 있습니다.  </p>
                <p>③ 일부 콘텐츠는 유료로 제공되며, 결제 전 명시적 안내가 진행됩니다. "취소" 선택 시 요금이 청구되지 않습니다.  </p>
                <p>④ 구글 월렛 등 지정 결제 수단을 통해 요금이 청구됩니다.  </p>
                <h2>**제4조 (이용자 의무)**</h2>
                <p>① 이용자는 (i) 합법적 사용, (ii) 제3자 권리 침해 금지를 준수해야 합니다.  </p>
                <p>② 앱 기능·데이터 변조·저작권 보호 기술 회피 행위 시 모든 책임을 집니다.  </p>
                <p>③ 당사 제품의 상업적 모방·디자인 복제·파생 제품 개발이 금지됩니다.  </p>
                <p>④ 불법 콘텐츠 업로드 시 법적 책임이 발생하며, 당사는 서비스 중단 및 손해배상 청구권을 보유합니다.  </p>
                <h2>**제5조 (권리 및 의무)**  </h2>
                <p>① 당사는 운영 필요에 따라 본 서비스를 수시로 수정·업데이트할 권리가 있습니다.  </p>
                <p>② 약관 위반 시 서비스 제한·법적 조치 등 조치를 취할 수 있습니다.  </p>
                <p>③ 당사는 사전 통지 없이 서비스 제공을 중단할 수 있습니다.  </p>
                <h2>**제6조 (면책 조항)**  </h2>
                <p>① 천재지변(태풍·지진·홍수 등), 해킹·통신 장애로 인한 서비스 중단 시 책임을 지지 않습니다.  </p>
                <p>② 기술적 결함 수정을 보장하지 않으며, 서비스 불만족 시 이용 중단이 유일한 해결책입니다.  </p>
                <p>③ 분쟁 발생 시 홍콩 특별행정구 법률에 따라 해결됩니다.  </p>
                <h2>**제7조 (자동 갱신 서비스)**  </h2>
                <p>① 구독 기간 종료 24시간 전까지 미해지 시 차기 요금이 자동 청구됩니다.  </p>
                <p>② 구독 주기: 1주/1년 등(구매 페이지 명시 사항 준수).  </p>
                <p>③ 신규 가입자 무료 체험 종료 후 미해지 시 유료 전환됩니다.  </p>
                <p>④ 요금 조정 시 사전 공지되며, 동의하지 않으면 해지가 가능합니다.  </p>
                <h2>**해지 방법**  </h2>
                <p>- **iOS**: 설정 > Apple ID > 구독 메뉴에서 해지  </p>
                <p>- **Android**: 구글 플레이 > 구독 메뉴에서 해지  </p>
                <h2>**제8조 (콘텐츠 정책)**  </h2>
                <p>① 아동 학대·성폭력·근친상간·수간 등 불법 콘텐츠는 즉시 삭제되며 작성자는 영구 제재됩니다.  </p>
                <p>② 콘텐츠 검수는 지속적으로 진행되며, 문의 사항은 ops@novellettes.com으로 연락 바랍니다.  </p>
                <h2>**부칙** </h2>
                <p>본 약관은 홍콩 특별행정구 법률의 관할을 받습니다.  </p>
            `
    },
    'ABOUT': {
        content: `
            <p>구독 해지 및 고객지원 안내</p>
            <p>해지 방법</p>
            <p>ops@novellettes.com으로 이메일 발송</p>
            <p>결제 계정 이메일 및 서비스 시작일 필수 기재</p>
            <p>고객문의</p>
            <p>• 이메일: ops@novellettes.com</p>
            <p>• 응답 시간: 24시간 이내</p>
        `
    },
    'VIP_INTEREST': {
        1: `10,000+ 베스트셀러 무제한 열람`,
        2: '주간 200+ 신간 지속 업데이트',
        3: '광고 없는 프리미엄 독서 환경'
    },
    'VIP_RULES': {
        content: `
            <p>가격: 첫 주 할인 후 원가 기준 청구</p>
            <p>열람 규정: 미구독 시 무료 회차 열람 가능</p>
            <p>결제 방식: 앱 스토어 계정 자동 결제</p>
            <p>자동 갱신: 구독 기간 종료 시 자동 연장</p>
            <p>청구 주기: 주간/월간 등 선택 주기마다 갱신 24시간 전까지 미해지 시 차기 요금 청구</p>
            <p>해지 조건: 갱신 예정일 24시간 전까지 자유롭게 해지 가능</p>
            <p>구독 관리: [설정 > 구독] 메뉴에서 실시간 확인 및 변경</p>
        
        `
    }
};